export default __webpack_public_path__ + "static/media/linkedin_logo.158fde73.svg";